export enum ToggleSwitchStatus {
  UNCHECKED = 'UNCHECKED',
  CHECKED = 'CHECKED',
  ACTIVE = 'ACTIVE',
}
